import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface IProps {
  className?: string,
  regionName: string,
}

export const RegionShortcut = ({
  regionName,
  className,
}: IProps) => (
  <div className={classNames(styles.wrapper, className)}>
    <span className={styles.resort}>
      {regionName}
    </span>
  </div>
);
